// TODO: [1] remove as breaking change
import * as lazyLoadReducer from './modules';
import LazyLoad from './components';

export default LazyLoad;

export { lazyLoadReducer };
